<template>
    <b-modal v-model="showModal" size="lg" @hidden="cancelar" @close="cancelar" button-size="md" hide-footer
        :title="prefix + ' ' + title">
        <b-card bg-variant="light">
            <div class="d-flex align-items-center justify-content-center">
                <strong>{{ almoxarifado.descricaoProduto }}</strong>
            </div>
        </b-card>

        <b-form-row @keyup.enter="load" class="align-items-center">
            <b-col lg="8" sm="12" class="text-left">
                <lg-form-input v-model="form.descricao" label="Descrição:" description=" " />
            </b-col>

            <b-col lg="1" sm="1" class="ml-4 d-flex justify-content-end align-items-center">
                <b-button id="limpar-vinculo-departamento" class="my-2" size="sm" style="height: 20px" pill
                    variant="primary" @click="limpar">
                    <div class="btn-size-alinhamento">
                        <b-icon icon="eraser" />
                    </div>
                    <b-tooltip target="limpar-vinculo-departamento" title="Limpar"></b-tooltip>
                </b-button>

                <b-button id="localizar-vinculo-departamento" class="ml-3 mr-2 my-2" size="sm" style="height: 20px" pill
                    variant="primary" @click="load">
                    <div class="btn-size-alinhamento">
                        <b-icon icon="search" />
                    </div>
                    <b-tooltip target="localizar-vinculo-departamento" title="Localizar"></b-tooltip>
                </b-button>
            </b-col>

            <b-col lg="2" sm="12" class="text-right d-flex justify-content-end align-items-center">
                <b-button id="novo-vinculo-departamento" class="ml-3 mr-2 my-2" style="height: 20px"
                    @click="mostrarUnidade()" size="sm" pill variant="secondary">
                    <div class="btn-size-alinhamento">
                        <b-icon scale="1" icon="plus" />
                    </div>
                    <b-tooltip target="novo-vinculo-departamento" title="Adicionar novo..."></b-tooltip>
                </b-button>
            </b-col>
        </b-form-row>


        <b-card bg-variant="light">
            <span>({{ quantidadesItens }}) item(s) selecionados</span>
            <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records" :fields="this.tableFields"
                :hover="true" show-empty>
                <template #head(select)>
                    <b-form-checkbox @change="selecionarTodos" v-model="todosSelecionados"
                        :id="'checkboxSelecionarTodos'" size="lg" :value="true" :unchecked-value="false" />

                </template>

                <template v-slot:cell(select)="row">
                    <b-form-checkbox @change="selecionarIndividual(row.item)" :id="'checkboxSelecionar' + row.item.id"
                        v-model="row.item.selecionado" size="lg" :value="true" :unchecked-value="false" />
                </template>

                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                    </div>
                </template>

                <template #empty>
                    <p>
                        Nenhum Registro encontrado
                    </p>
                </template>


                <template v-slot:cell(excluir)="row">
                    <b-button :id="row.index + 'excluir-unidade-almoxarifado-vinculo'" class="my-2" size="sm" pill
                        variant="primary" @click="remove(row.item)">
                        <b-icon icon="trash-fill" />
                        <b-tooltip :target="row.index + 'excluir-unidade-almoxarifado-vinculo'"
                            title="Remover..."></b-tooltip>
                    </b-button>
                </template>


            </b-table>

            <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                        {{
                            totalPage }} -
                        {{ total }} registros</b-col>
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                        <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                            :options="perPageOptions">
                        </b-form-select>
                    </b-col>
                </b-col>
                <b-col cols="6">
                    <div class="d-flex justify-content-end align-items-end">
                        <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page" :per-page="perPage"
                            :total-rows="total"></b-pagination>
                    </div>
                </b-col>
            </b-row>
        </b-card>

        <b-form-row>

            <b-col cols="3"></b-col>
            <b-col cols="6" class="text-center">
                <b-button id="salvarVinculoUnidade" class=" my-2" size="sm" pill variant="success" @click="aceitar">
                    <b-icon icon="check-circle" />
                    <b-tooltip target="salvarVinculoUnidade" title="Aceitar"></b-tooltip>

                </b-button>

                <b-button id="cancelarVinculoUnidade" class=" my-2 ml-2" size="sm" pill variant="danger"
                    @click="cancelar">
                    <b-icon icon="x-circle" />
                    <b-tooltip target="cancelarVinculoUnidade" title="Cancelar"></b-tooltip>

                </b-button>
            </b-col>
            <b-col cols="3"></b-col>

        </b-form-row>

        <ModalPageUnidadeAdministrativa :id="'finder-Almoxarifado-Departamento-vinculo'" v-if="showUnidade"
            @onselect="addUnidadeSelect" :prefix="prefix + ' ' + title + ' > '"></ModalPageUnidadeAdministrativa>



    </b-modal>
</template>

<script>
import ResourceService from "@/core/api/ResourceService";
import ConfirmMixin from "@/core/mixins/confirm"
import { ListResourceMixin, FormResourceMixin } from "@/core/mixins/resource";
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import ModalPageUnidadeAdministrativa from "@/core/components/Modals/ModalPageUnidadeAdministrativa.vue";
import Swal from "sweetalert2"

export default {
    components: {
        LgFormInput,
        ModalPageUnidadeAdministrativa
    },
    props: {
        almoxarifado: {
            type: Object,
            default: null,
        },
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Associar Unidades Administrativas",
        },
    },

    data() {
        return {
            perPageOptions: [10, 25, 50, 100],

            itensSelecionados: [],
            showUnidade: false,
            form: { descricao: "" },
            showModal: true,

        }
    },
    mixins: [ListResourceMixin, ConfirmMixin, FormResourceMixin],


    watch: {
        page() {
            this.load()
        },
    },


    async beforeMount() {
        this.$service = new ResourceService(`/api/almoxarifados/${this.almoxarifado.id}/departamentos/produtos`);
        this.load();
    },
    methods: {
        selecionarIndividual(item) {
            if (item.selecionado)
                this.itensSelecionados.push(item.id);
            else
                this.itensSelecionados.splice(this.records.find(
                    recordSelecionado => item.id == recordSelecionado.id
                ), 1);

        },
        selecionarTodos(valor) {
            this.itensSelecionados = [];

            this.records.forEach(record => {
                record.selecionado = valor;

                if (valor)
                    this.itensSelecionados.push(record.id);
                else
                    this.itensSelecionados.splice(this.records.find(
                        recordSelecionado => record.id == recordSelecionado.id
                    ), 1);

            });

        },

        async aceitar() {

            if (this.itensSelecionados == 0) {
                this.$notify({
                    type: "danger",
                    message: 'Nenhum item selecionado'
                });
                return;
            }

            const value = await Swal.fire({
                title: "Tem certeza que deseja excluir?",
                text: "Esta ação não poderá ser desfeita!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
            }).then(({ value }) => {
                return value;
            });

            if (!value) {
                return;
            }
            this.busy = true;
            await this.$service.removeList(this.itensSelecionados)
            this.$notify({
                type: "success",
                message: "Registro excluído com sucesso!",
            });

            this.itensSelecionados = [];
            this.load();
        },
        async remove(item) {
            await this.$removeResource(item)
        },

        async addUnidadeSelect(item) {
            if (!item || !item.id) {
                this.showUnidade = false;

                return;
            }
            if (!this.records)
                this.records = [];

            const itemExistente = this.records.find(
                record => record.idDepartamento === item.id
            );

            if (itemExistente) {
                this.$notify({
                    type: "danger",
                    message: 'Unidade Administrativa já existe'
                });

                return;
            }
            this.busy = true;
            try {
                await this.$saveResource({ idAlmoxarifado: this.almoxarifado.id, idDepartamento: item.id }, "", false, {}, false, true);
                this.load();
            }
            catch (error) {
                this.$notify({
                    type: "danger",
                    message: error.response.data
                });

            }
            this.showUnidade = false;
        },
        mostrarUnidade() {
            this.showUnidade = true;
        },
        limpar() {
            this.form.descricao = "";
            this.load();
        },
        async load() {

            this.filtro = {}

            if (this.form.descricao && this.form.descricao != "") {
                this.filtro.descricao = this.form.descricao
            }


            this.busy = true
            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtro,
            });

            this.itensSelecionados.forEach(recordSelecionado => {
                if (this.records)
                    this.records.forEach(record => {
                        if (recordSelecionado == record.id)
                            record.selecionado = true;
                    });
            }
            )
            this.busy = false;

        },

        cancelar() {
            this.$emit("close")
        },
    },

    computed: {
        todosSelecionados: {
            get() {
                return this.records && this.records.length > 0 && this.records.every(i => i.selecionado);
            },
            set(valor) {
                this.records.forEach(i => i.selecionado = valor);
            }
        },

        quantidadesItens() {
            return this.itensSelecionados.length
        },
        tableFields() {
            return [

                {
                    key: "select",
                    label: "",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "w-1",
                },

                {
                    key: "sigla",
                    label: "sigla",
                    thStyle: "font-size: 10px; font-weight: 400;",
                    tdStyle: "font-size: 10px",
                },
                {
                    key: "descricao",
                    label: "Descrição",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },

                {
                    key: "excluir",
                    label: "",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "w-1",
                },
            ]
        },
    }

}
</script>